import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type"]

import { reactive, watch, onMounted, nextTick } from 'vue'
  import { fdata, addDays, curUs, isDate, f2dec, f3dec, f4dec, f5dec, fdataUS, fdataUSS, fdataHora, fdataHoraUS, stringParaDataISO } from '@/utils/funcoes';

  export type iFormato = "Texto" | "Numero" | "DoisDecimais" | "TresDecimais" | "QuatroDecimais" | "CincoDecimais" | "Data" | "DataHora" | "CNPJ" | "Telefone" | "Cep" | "Maiusculo" | "Minusculo" | "Senha";

  interface iProps {
    modelValue?: any,
    value?: any,
    formato?: iFormato;
    aoDigitar?: boolean;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    modelValue: {},
    value: {},
    formato: {},
    aoDigitar: { type: Boolean }
  },
  emits: ['alteraValor', 'focusout', "keyup", "update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

  const emit = __emit;

  var props = __props;

  var controle = reactive({
    valorReal: props.modelValue != undefined ? props.value : "",
    valorExibir: props.modelValue != undefined ? props.value : "",
    formato: props.formato,
    type: "text",
    classe: "",
    valorAntigo: "" as any,
  })

  onMounted(async () => {
    var valor = props.modelValue != null ? props.modelValue : props.value;
    configurar(valor);
  })

  watch(() => props.modelValue, async (novo: any) => {
    if (controle.valorReal != novo) {
      controle.valorReal = novo;
      formataParaExibir();
    }
  })

  function configurar(valor: any) {
    if (props.formato == 'Data') {
      controle.type = "text";
      controle.valorReal = stringParaDataISO(valor)
    }
    else if (props.formato == 'DataHora') {
      controle.type = "text";
      controle.valorReal = fdataHora(valor);
    }
    else if (props.formato == 'DoisDecimais') {
      controle.type = "text";
      controle.valorReal = curUs(valor, 2);
    }
    else if (props.formato == 'TresDecimais') {
      controle.type = "text";
      controle.valorReal = curUs(valor, 3);
    }
    else if (props.formato == 'QuatroDecimais') {
      controle.type = "text";
      controle.valorReal = curUs(valor, 4);
    }
    else if (props.formato == 'CincoDecimais') {
      controle.type = "text";
      controle.valorReal = curUs(valor, 5);
    }
    else if (props.formato == 'Numero') {
      controle.type = "number";
      controle.valorReal = valor;
    }
    else if (props.formato == 'Texto') {
      controle.type = "text";
      controle.valorReal = valor;
    }
    else if (props.formato == 'Senha') {
      controle.type = "password";
      controle.valorReal = valor;
    }
    else if (props.formato == 'CNPJ') {
      controle.type = "text";
      controle.classe = "cnpj";

      controle.valorReal = formatarCpfCnpj(valor);
      nextTick(() => {
        var el = document.querySelector(".cnpj");
        el?.setAttribute('minlength', "11");
        el?.setAttribute('maxlength', "18");
      })
    }
    else if (props.formato == 'Telefone') {
      controle.type = "text";
      controle.classe = "telefone";

      controle.valorReal = formatarTelefone(valor);
      nextTick(() => {
        var el = document.querySelector(".telefone");
        el?.setAttribute('minlength', "10");
        el?.setAttribute('maxlength', "15");
      })
    }
    else if (props.formato == 'Cep') {
      controle.type = "text";
      controle.classe = "cep";

      controle.valorReal = formatarCep(valor);
      nextTick(() => {
        var el = document.querySelector(".cep");
        el?.setAttribute('minlength', "8");
        el?.setAttribute('maxlength', "9");
      })
    }
    else if (props.formato == 'Maiusculo') {
      controle.type = "text";
      controle.classe = "text-uppercase";
    }
    else if (props.formato == 'Minusculo') {
      controle.type = "text";
      controle.classe = "text-lowercase";
    }
    else {
      controle.type = "text";
      controle.valorReal = valor;
    }

    formataParaExibir();
  }

  function formataParaExibir() {
    if (props.formato == 'Data') {
      controle.valorExibir = fdata(controle.valorReal)

    }
    else if (props.formato == 'DataHora') {
      controle.valorExibir = fdataHora(controle.valorReal);
    }
    else if (props.formato == 'DoisDecimais') {
      controle.valorReal = curUs(controle.valorReal, 2);
      controle.valorExibir = f2dec(controle.valorReal, 2);
    }
    else if (props.formato == 'TresDecimais') {
      controle.valorReal = curUs(controle.valorReal, 3);
      controle.valorExibir = f3dec(controle.valorReal, 3);
    }
    else if (props.formato == 'QuatroDecimais') {
      controle.valorReal = curUs(controle.valorReal, 4);
      controle.valorExibir = f4dec(controle.valorReal, 4);
    }
    else if (props.formato == 'CincoDecimais') {
      controle.valorReal = curUs(controle.valorReal, 5);
      controle.valorExibir = f5dec(controle.valorReal, 5);
    }
    else if (props.formato == 'CNPJ') {
      controle.valorExibir = formatarCpfCnpj(controle.valorReal);

    }
    else if (props.formato == 'Telefone') {
      controle.valorExibir = formatarTelefone(controle.valorReal);
    }
    else if (props.formato == 'Cep') {
      controle.valorExibir = formatarCep(controle.valorReal);
    }
    else if (props.formato == 'Numero') {
      controle.valorExibir = String(controle.valorReal).replace(/\D/g, "");
    }
    else
      controle.valorExibir = controle.valorReal;
  }

  // watch(() => props.value, async (novo: any) => {
  //   controle.valorReal = novo != null ? novo : controle.valorReal;

  //   if (props.formato == 'DoisDecimais')
  //     controle.valorReal = curUs(controle.valorReal, 2)
  //   else if (props.formato == 'TresDecimais')
  //     controle.valorReal = curUs(controle.valorReal, 3);
  //   else if (props.formato == 'Data')
  //     controle.valorReal = fdata(controle.valorReal)
  //   else if (props.formato == 'CNPJ')
  //     controle.valorReal = formatarCpfCnpj(controle.valorReal);
  //   else if (props.formato == 'Telefone')
  //     controle.valorReal = formatarTelefone(controle.valorReal);
  //   else if (props.formato == 'Cep')
  //     controle.valorReal = formatarCep(controle.valorReal);
  // })



  function formatarAoDigitar() {
    if (props.formato == 'DoisDecimais') {
      controle.valorReal = curUs(controle.valorExibir, 2);
    }
    else if (props.formato == "TresDecimais") {
      controle.valorReal = curUs(controle.valorExibir, 3);
    }
    else if (props.formato == "QuatroDecimais") {
      controle.valorReal = curUs(controle.valorExibir, 4);
    }
    else if (props.formato == "CincoDecimais") {
      controle.valorReal = curUs(controle.valorExibir, 5);
    }
    else if (props.formato == "Data") {
      //controle.valorExibir = formatarData(controle.valorExibir);

      controle.valorReal = fdataUS(controle.valorExibir);
    }
    else if (props.formato == "DataHora") {
      controle.valorReal = fdataHoraUS(controle.valorExibir);
    }
    else if (props.formato == 'CNPJ') {
      controle.valorExibir = formatarCpfCnpj(controle.valorExibir);
      controle.valorReal = controle.valorExibir;
    }
    else if (props.formato == 'Telefone') {
      controle.valorExibir = formatarTelefone(controle.valorExibir);
      controle.valorReal = controle.valorExibir;
    }
    else if (props.formato == 'Cep') {
      controle.valorExibir = formatarCep(controle.valorExibir);
      controle.valorReal = controle.valorExibir;
    }
    else if (props.formato == 'Maiusculo') {
      controle.valorExibir = controle.valorExibir.toUpperCase();
      controle.valorReal = controle.valorExibir;
    }
    else if (props.formato == 'Minusculo') {
      controle.valorExibir = controle.valorExibir.toLowerCase();
      controle.valorReal = controle.valorExibir;
    }
    else if (props.formato == 'Numero') {
      const somenteDigitos = String(controle.valorExibir ?? "").replace(/\D/g, "");
      controle.valorReal = somenteDigitos === "" ? null : somenteDigitos;
    }
    else
      controle.valorReal = controle.valorExibir;

    if (props.aoDigitar == true) {
      emit("update:modelValue", controle.valorReal);
      emit("change", controle.valorReal);
    }
  }

  const confereValor = () => {

    var alterouValor = false;

    if (props.formato == 'DoisDecimais') {
      controle.valorReal = curUs(controle.valorExibir, 2);
      controle.valorExibir = f2dec(controle.valorReal, 2);
      alterouValor = controle.valorReal != curUs(controle.valorAntigo, 2)
    }
    else if (props.formato == "TresDecimais") {
      controle.valorReal = curUs(controle.valorExibir, 3);
      controle.valorExibir = f3dec(controle.valorReal, 3);
      alterouValor = controle.valorReal != curUs(controle.valorAntigo, 3)
    }
    else if (props.formato == "QuatroDecimais") {
      controle.valorReal = curUs(controle.valorExibir, 4);
      controle.valorExibir = f4dec(controle.valorReal, 4);
      alterouValor = controle.valorReal != curUs(controle.valorAntigo, 4)
    }
    else if (props.formato == "CincoDecimais") {
      controle.valorReal = curUs(controle.valorExibir, 5);
      controle.valorExibir = f5dec(controle.valorReal, 5);
      alterouValor = controle.valorReal != curUs(controle.valorAntigo, 5)
    }
    else if (props.formato == "Data") {
      controle.valorExibir = formatarData(controle.valorExibir);
      controle.valorReal = fdataUSS(controle.valorExibir);
      alterouValor = controle.valorReal != controle.valorAntigo;
    }
    else if (props.formato == "DataHora") {
      controle.valorExibir = formatarDataHora(controle.valorExibir);
      controle.valorReal = fdataHoraUS(controle.valorExibir);
      alterouValor = controle.valorReal != controle.valorAntigo;
    }
    else if (props.formato == "Numero") {
      const somenteDigitos = String(controle.valorExibir ?? "").replace(/\D/g, "");
      controle.valorReal = somenteDigitos === "" ? null : somenteDigitos;
      alterouValor = controle.valorReal != controle.valorAntigo;
    }
    else
      alterouValor = controle.valorReal != controle.valorAntigo;

    emit("update:modelValue", controle.valorReal);

    if (alterouValor)
      emit("alteraValor", controle.valorReal);
  }

  function formatarDataHora(valor: any) {
    try {
      if (valor == null || valor === "") return "";

      valor = valor.toString().trim();

      // Já está formatado: dd/mm/yyyy HH:MM ou dd/mm/yyyy HH:MM:SS
      if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}/.test(valor)) return valor;

      // Apenas dígitos: ddMMyyyyHHMM (12) ou ddMMyyyyHHMMSS (14)
      const digits = valor.replace(/\D/g, "");
      if (digits.length >= 12) {
        const dd = digits.substring(0, 2);
        const mm = digits.substring(2, 4);
        const yyy = digits.substring(4, 8);
        const HH = digits.substring(8, 10);
        const MM = digits.substring(10, 12);
        return `${dd}/${mm}/${yyy} ${HH}:${MM}`;
      }

      // Fallback: tenta exibir como data e hora via helper
      return fdataHora(valor);
    } catch (error) {
      console.log("erro em TextBox formatarDataHora:", error);
      return valor;
    }
  }

  function formatarData(valor: any) {
    try {
      if (valor == null || valor === "") return "";

      var dias = 0;

      if (valor.toString().toLowerCase().includes("h")) {
        let idx = (valor.toString().indexOf("+"));
        if (idx > 0) {
          dias = parseInt(valor.substring(idx));
        }
        else {
          idx = (valor.toString().indexOf("-"));
          if (idx > 0) {
            dias = parseInt(valor.substring(idx));
          }
        }
        valor = fdata(addDays(Date.now(), dias))?.toString();
      }
      else if (valor.toString().toLowerCase().includes("a")) {
        valor = fdata(addDays(Date.now(), 1))?.toString();
      }
      else if (valor.toString().toLowerCase().includes("o")) {
        valor = fdata(addDays(Date.now(), -1))?.toString();
      }
      else if (valor.toString().length == 4) {
        const dia = valor.substring(0, 2);
        const mes = valor.substring(2);
        const ano = new Date().getFullYear();
        const data = `${ano}-${mes}-${dia}`;
        valor = fdata(data)?.toString();
      }
      else if (valor.toString().length == 6) {
        const dia = valor.substring(0, 2);
        const mes = valor.substring(2, 4);
        const ano = parseInt(`${new Date().getFullYear().toString().substring(0, 2)}${valor.substring(4)}`);
        const data = `${ano}-${mes}-${dia}`;
        valor = fdata(data)?.toString();
      }
      else if (valor.toString().length == 8) {
        const dia = valor.substring(0, 2);
        const mes = valor.substring(2, 4);
        const ano = parseInt(valor.substring(4));
        const data = `${ano}-${mes}-${dia}`;
        valor = fdata(data)?.toString();
      }

      return valor;
    } catch (error) {
      console.log("erro em TextBox:", error);
    }
  }

  function formatarCpfCnpj(valor: any) {
    valor = valor?.replace(/\D/g, "");

    if (valor?.length <= 11) {
      // Formatar CPF
      return valor?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else {
      // Formatar CNPJ
      return valor?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
  }

  function formatarTelefone(valor: any) {

    if (valor?.length <= 10) {
      // Formatar telefone: (XX) XXXX-XXXX
      return valor?.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    } else {
      // Formatar celular: (XX) 9XXXX-XXXX
      return valor?.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }
  }

  function formatarCep(valor: any) {

    // Formatar cep: XXXXX-XXXX
    if (valor != null) {
      valor = valor.replace("-", "");
      if (valor.length > 8)
        valor = valor.substring(0, 8);

      return valor?.replace(/(\d{5})(\d{3})/, "$1-$2");
    }
    else
      return valor;

  }

  function focusin(ev: FocusEvent) {
    if (ev != null && ev.target != null) {
      controle.valorAntigo = (ev.target as HTMLInputElement)?.value;
      (ev.target as HTMLInputElement).select();
    }
  }

  function focusOut(ev: FocusEvent) {
    confereValor();
    emit('focusout')
  }

  function onKeyUp(ev: KeyboardEvent) {
    emit('keyup', ev);
  }

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    type: _unref(controle).type,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).valorExibir) = $event)),
    class: _normalizeClass(_unref(controle).classe),
    onFocusin: _cache[1] || (_cache[1] = ev => focusin(ev)),
    onFocusout: _cache[2] || (_cache[2] = ev => focusOut(ev)),
    onInput: formatarAoDigitar,
    onKeyup: _cache[3] || (_cache[3] = ev => onKeyUp(ev))
  }, null, 42, _hoisted_1)), [
    [_vModelDynamic, _unref(controle).valorExibir]
  ])
}
}

})